import React from "react";
import useScrollReveal from "../hooks/useScrollReveal";
import "../../styles/module/collaborate.css";

import phone_icon from "../../assets/images/icons/phone-white.svg";
import email_icon from "../../assets/images/icons/email-white.svg";

export default function Collaborate() {
  useScrollReveal("slide-from-left");
  useScrollReveal("slide-from-right");
  return (
    <div className="section section__ready-to-cooperate">
      <div className="container flex">
        <div className="left slide-from-left">
          <h2 className="white">
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                Let's Get Connected
              </font>
            </font>
          </h2>
          <p>
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>
                If our approach aligns with your vision, we’d love to discuss
                how we can elevate your business.
              </font>
            </font>
          </p>
          <button
            onClick={() => (window.location.href = "/contact")}
            className="btn blue"
          >
            <font style={{ verticalAlign: "inherit" }}>
              <font style={{ verticalAlign: "inherit" }}>Contact us</font>
            </font>
          </button>
        </div>
        <div className="right slide-from-right">
          <div className="data">
            <div className="tel">
              <h5>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit", color: "white" }}>
                    Call
                  </font>
                </font>
              </h5>
              <div className="tel-number">
                <img
                  loading="lazy"
                  src={phone_icon}
                  alt="phone icon"
                  className="icon"
                />
                <a className="phone-clickable" href="tel:+9779762688171">
                  <h2 className="phone-number">
                    <font style={{ verticalAlign: "inherit" }}>
                      <font style={{ verticalAlign: "inherit" }}>
                        +977-9762688171
                      </font>
                    </font>
                  </h2>
                </a>
              </div>
            </div>
            <div className="mail">
              <h5>
                <font style={{ verticalAlign: "inherit" }}>
                  <font style={{ verticalAlign: "inherit", color: "white" }}>
                    Mail
                  </font>
                </font>
              </h5>
              <div className="mail-address">
                <img
                  loading="lazy"
                  src={email_icon}
                  alt="email icon"
                  className="icon"
                />
                <a href="mailto:info@genvixtech.com">
                  <h2 className="mail-address-link">
                    <font style={{ verticalAlign: "inherit" }}>
                      <font style={{ verticalAlign: "inherit" }}>
                        info@genvixtech.com
                      </font>
                    </font>
                  </h2>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
